import { useHistory } from 'react-router-dom';
import { userHasBadAccountStatus } from '@common/helpers/auth';
import { useSiteCountryCode } from '@common/hooks/localisation';
import { useRedirect } from '@common/hooks/useRedirect';
import { useCurrentUser, useHasAuthentication } from '@common/hooks/user';
import { logout } from '@store/auth';
import { getEnvironment, getSiteId } from '@store/config';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { isCajaRoute } from './isCajaRoute';

export const useJoraEmployerHeader = () => {
  const history = useHistory();
  const { redirect } = useRedirect();
  const dispatch = useAppDispatch();
  const isAuthenticated = useHasAuthentication();
  const currentUser = useCurrentUser();
  const countryCode = useSiteCountryCode();
  const environment = useAppSelector(getEnvironment());
  const siteId = useAppSelector(getSiteId());
  const badAccountStatus = userHasBadAccountStatus(currentUser);

  const currentPathname = history.location?.pathname;
  const isCajaPage = isCajaRoute(currentPathname);
  const isNotHomeRoute = currentPathname !== `/${countryCode}/`;

  return {
    isAuthenticated,
    badAccountStatus,
    siteId,
    isDevelopment: environment === 'development',
    showBackButton: !badAccountStatus && isNotHomeRoute && !isCajaPage,
    goBack: () => history.goBack(),
    goToLogin: () => redirect(`/${countryCode}/login`)(),
    logOut: () => dispatch(logout({ initiatedByUser: true })),
    goToHome: () => redirect(`/${countryCode}/`)()
  };
};
